import React, { useRef, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const useResizeEffect = (onResize, deps = []) => {
  useEffect(() => {
    onResize();
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, onResize]);
};

function ShowMore({ more, less, maxHeight, children, buttonPosition }) {
  const [isOverflowing, setIsOverFlowing] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [container, setContainer] = useState(null);

  // this has to be done by ref so when window event resize listener will trigger - we will get the current element
  const containerRef = useRef(container);
  containerRef.current = container;
  const setScrollableOnResize = useCallback(() => {
    if (!containerRef.current) return;
    const { clientHeight, scrollHeight } = containerRef.current;
    setIsOverFlowing(scrollHeight > clientHeight);
  }, [containerRef]);
  useResizeEffect(setScrollableOnResize, [containerRef]);

  return (
    <>
      <div
        style={{
          maxHeight: isExpanded ? '' : maxHeight,
          overflow: isExpanded ? '' : 'hidden',
          position: 'relative',
        }}
        ref={element => {
          if (!element) return;
          setContainer(element);
          const { clientHeight, scrollHeight } = element;
          setIsOverFlowing(scrollHeight > clientHeight);
        }}
      >
        {children}
        {isOverflowing && !isExpanded && (
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              backgroundImage: 'linear-gradient(to bottom, transparent, white)',
              height: '40px',
            }}
          />
        )}
      </div>
      <div className={`text-${buttonPosition} mb-3`}>
        {isOverflowing && !isExpanded && (
          <>
            <Button
              color="link"
              className="link-animated link-animated-light"
              onClick={() => setIsExpanded(true)}
            >
              {more}
            </Button>
          </>
        )}
        {isExpanded && (
          <Button
            color="link"
            className="link-animated link-animated-light"
            onClick={() => setIsExpanded(false)}
          >
            {less}
          </Button>
        )}
      </div>
    </>
  );
}

ShowMore.propTypes = {
  more: PropTypes.string,
  less: PropTypes.string,
  maxHeight: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  buttonPosition: PropTypes.oneOf(['start', 'center', 'end']),
};

ShowMore.defaultProps = {
  more: 'Visa mer',
  less: 'Visa mindre',
  buttonPosition: 'end',
};
export default ShowMore;
